import DataWrapper from './DataWrapper';

export default DataWrapper;